{
  "ancillaries": {
    "bundle": {
      "conflictingBundle": "You may not edit the flight details in this view due to the selected ",
      "unavailableBundle": "The combo is not available for this flight and passenger combination.",
      "quotaReached": "The maximum number of combo offers has been selected. No more combos can be added.",
      "toggle": {
        "titles": {
          "seatWifi": "",
          "seatPriority": "",
          "seatCabinBaggage": "",
          "seatMeal": ""
        },
        "descriptions": {
          "seatWifi": "",
          "seatPriority": "",
          "seatCabinBaggage": "",
          "seatMeal": ""
        },
        "buttonText": {
          "showCombos": "Show combo offers",
          "showingCombos": "Showing combo offers",
          "comboAdded": "Added",
          "addForPrice": "Add for {price}"
        }
      },
      "upsellCard": {
        "seatWifi": {
          "buttonText": {
            "addCombo": "Add combo",
            "added": "Added"
          },
          "addCombo": {
            "productCardTitle": "Seat + {productName}",
            "title": "10% off when booked together",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          },
          "addProduct": {
            "title": "Get internet for less withn a seat",
            "image": {
              "alt": "",
              "contentId": 3560630,
              "data": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg",
              "teaserTitle": "",
              "responsiveImageLinksData": {
                "landscape_ratio21x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=1714&x=0&y=791"
                },
                "landscape_ratio16x9": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=4000&height=2250&x=0&y=278"
                },
                "portrait_ratio1x1": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=2666&height=2666&x=681&y=0"
                },
                "landscape_ratio4x3": {
                  "768": "https://cms.finnair.com/resource/blob/3560630/80aa2cea7e79a9379824866463d55f13/stream-full-flight-data.jpg?impolicy=crop&width=3555&height=2666&x=445&y=0"
                }
              }
            }
          }
        }
      }
    },
    "seatMeal": {
      "extraTitle": "Seat + Meal Combo",
      "offersToggle": {
        "title": {
          "seatHotPreOrderMeal": "10% off when you add seat and meal together",
          "seatFreshMeal": "10% off when you add seat and meal together"
        },
        "description": {
          "seatHotPreOrderMeal": "Seat of your choice + Savoury chicken & drink meal (chicken breast with caponata and spinach tagliatelle)",
          "seatFreshMeal": "Seat of your choice + Northern Choice meal (smoothie, salmon rye sandwich, chocolate, coffee or tea)"
        }
      },
      "selectedToggle": {
        "title": {
          "seatHotPreOrderMeal": "10% off when you add a meal with your seat",
          "seatFreshMeal": "10% off when you add a meal with your seat"
        },
        "description": {
          "seatHotPreOrderMeal": "Savoury chicken & drink meal (chicken breast with caponata and spinach tagliatelle)",
          "seatFreshMeal": "Northern Choice meal (smoothie, salmon rye sandwich, chocolate, coffee or tea)"
        }
      }
    },
    "seatPriority": {
      "extraTitle": "Seat + Priority Combo",
      "offersToggle": {
        "title": {
          "seatPriorityServices": "10% off when you add seat and priority services together"
        },
        "description": {
          "seatPriorityServices": "Seat of your choice + Access to priority check-in and security"
        }
      },
      "selectedToggle": {
        "title": {
          "seatPriorityServices": "10% off when you add priority services with your seat"
        },
        "description": {
          "seatPriorityServices": "Access to a dedicated priority check-in desk and security lane"
        }
      }
    },
    "seatWifi": {
      "extraTitle": "Seat + Internet Combo",
      "offersToggle": {
        "title": {
          "seatWifi": "10% off when you add seat and internet together"
        },
        "description": {
          "seatWifi": "Seat of your choice + Stream package for the entire flight"
        }
      },
      "selectedToggle": {
        "title": {
          "seatWifi": "10% off when you add internet to your seat"
        },
        "description": {
          "seatWifi": "Stream package for the entire flight"
        }
      }
    },
    "seatCabinBaggage": {
      "extraTitle": "Seat + Baggage Combo",
      "offersToggle": {
        "title": {
          "seatCabinBaggage": "10% off when you add seat and carry-on bag together"
        },
        "description": {
          "seatCabinBaggage": "Seat of your choice + Carry-on (total weight with a small bag: 8 kg)"
        }
      },
      "selectedToggle": {
        "title": {
          "seatCabinBaggage": "10% off when you add a carry-on with your seat"
        },
        "description": {
          "seatCabinBaggage": "Carry-on bag (55 × 40 × 23 cm). Total weight with a small bag: 8 kg."
        }
      }
    },
    "seat": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, seats <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, seats <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "seatCombos": {
      "noSeatCombosAvailable": "Sorry, combo offers cannot be selected online for this flight.",
      "noSeatCombosAvailableBus": "Sorry, combo offers cannot be selected in advance for the bus connection.",
      "noSeatCombosAvailableForOperatingAirline": "The flight is operated by {airline}.",
      "eligibility": {
        "notAvailableBus": "Unfortunately, combo offers <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, combo offers <b>cannot be added for this part of your journey on our site</b> because this is a train connection.",
        "boundFlown": "This flight has already departed."
      }
    },
    "meals": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, meals <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, meals <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "lounge": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, lounge <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, lounge <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "wifi": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, internet <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, internet <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "bags": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "cabinBaggage": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "pet": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, pets <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, pets <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "sport": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, sports equipment <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, sports equipment <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "productList": {
      "subtitle": {
        "topPick": "Top pick for this flight:",
        "generic": "Choose from these options:",
        "added": "You've added:"
      }
    }
  },
  "purchase": {
    "payment": {
      "seatMealCount": "Combos x {bundleCount}",
      "seatPriorityCount": "Combos x {bundleCount}",
      "seatWifiCount": "Combos x {bundleCount}",
      "seatCabinBaggageCount": "Combos x {bundleCount}",
      "bundleCount": ""
    }
  },
  "upsellCard": {
    "description": {
      "genericLongHaul": "Compare the meal service, seats and entertainment in different travel classes on long-haul flights."
    },
    "modalLink": {
      "allClasses": "Travel class differences"
    }
  },
  "upsellPromotion": {
    "totalPriceInfo": "Total price for all passengers",
    "selected": "Selected",
    "changeToClassic": "Change to Classic",
    "continueWithLight": "Continue with Light",
    "continueWithSuperLight": "Continue with Superlight"
  },
  "services": {
    "bundle": {
      "state": {
        "modify": {
          "ariaText": "",
          "text": ""
        },
        "purchased": {
          "default": "",
          "plural": "",
          "singular": ""
        },
        "select": {
          "ariaText": "",
          "text": ""
        },
        "selection": {
          "default": "",
          "plural": "",
          "singular": ""
        },
        "updating": {
          "ariaText": ""
        }
      }
    },
    "seatWifi": {
      "state": {
        "modify": {
          "ariaText": "Modify combo selections",
          "text": "Modify"
        },
        "purchased": {
          "default": "No combos selected yet",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "select": {
          "ariaText": "Select combos",
          "text": "Select"
        },
        "selection": {
          "default": "No combos selected",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "updating": {
          "ariaText": "Confirming combo selections"
        }
      }
    },
    "seatMeal": {
      "state": {
        "modify": {
          "ariaText": "Modify combo selections",
          "text": "Modify"
        },
        "purchased": {
          "default": "No combos selected yet",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "select": {
          "ariaText": "Select combos",
          "text": "Select"
        },
        "selection": {
          "default": "No combos selected",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "updating": {
          "ariaText": "Confirming combo selections"
        }
      }
    },
    "seatCabinBaggage": {
      "state": {
        "modify": {
          "ariaText": "Modify combo selections",
          "text": "Modify"
        },
        "purchased": {
          "default": "No combos selected yet",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "select": {
          "ariaText": "Select combos",
          "text": "Select"
        },
        "selection": {
          "default": "No combos selected",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "updating": {
          "ariaText": "Confirming combo selections"
        }
      }
    },
    "seatPriority": {
      "state": {
        "modify": {
          "ariaText": "Modify combo selections",
          "text": "Modify"
        },
        "purchased": {
          "default": "No combos selected yet",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "select": {
          "ariaText": "Select combos",
          "text": "Select"
        },
        "selection": {
          "default": "No combos selected",
          "plural": "{numberOfItems} combos selected",
          "singular": "1 combo selected"
        },
        "updating": {
          "ariaText": "Confirming combo selections"
        }
      }
    }
  },
  "stepperContinueText": {
    "travelExtras": "Continue to checkout"
  }
}
